module.exports = __webpack_public_path__ + "img/user_vector.c3d89091.png";